
<div class="container-fluid header">
  <nav class="navbar container-xxl navbar-expand-sm bg-body-tertiary">
    <a class="navbar-brand" href="/">
      <ng-content select="app-brand"></ng-content>
    </a>
    <button (click)="isMenuCollapsed = !isMenuCollapsed" class="navbar-toggler" type="button" aria-controls="navbarNav"
            [attr.aria-expanded]="!isMenuCollapsed" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav mb-2 mb-lg-0">
        <li class="nav-item" *ngFor="let link of filteredLinks">
          <a class="nav-link" [routerLink]="link.path" routerLinkActive="active" ariaCurrentWhenActive="page">{{link.label}}</a>
        </li>
      </ul>
    </div>
  <ul class="nav justify-content-end">
    <app-st-current-user-navicon *ngIf="isAuthenticated"></app-st-current-user-navicon>
  </ul>
  </nav>

</div>
